/**
 * @file contact.pipe.ts
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contact'
})
export class ContactPipe implements PipeTransform {

  transform(value: string | undefined): string {
    if (value && value.length >= 10) {
      const str = value.split('');
      str.splice(0, 0, '(');
      str.splice(4, 0, ')');
      str.splice(5, 0, ' ');
      str.splice(9, 0, '-');
      return str.join('');
    } else {
      return value || '';
    }
  }

}
